import React, { useState } from "react";
import "./affecteEleve.scss";

import { Close, EditRoad } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import {
  classeType,
  EleveType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType";
import { accountService } from "../../../_services/accountServices";
import toast, { LoaderIcon } from "react-hot-toast";
import { API_ELEVE } from "../../../apiCaller/eleve.Caller";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import { useNavigate } from "react-router-dom";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: EleveType | undefined;
  currentYear: string;
  dataClasse: classeType[];
  dataYear: schooYearType[];
  dispatchReload: () => void;
}
const AffecteEleve = (props: Props) => {
  const [classeDesignationId, setClasseDesignationId] = useState("");
  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  let yearId: number | string;
  for (const value of props.dataYear) {
    if (
      value.annee_scolaire_designation
        .toLowerCase()
        .includes(props.currentYear.toLowerCase())
    ) {
      yearId = value.annee_scolaire_id;
    }
  }
  const navigate = useNavigate();

  const handleAffecteClasse = async () => {
    if (classeDesignationId.toString().length < 1) {
      return toast.error("Veuillez selectionner la nouvelle classe", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
        },
      });
    }
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let data = {
        eleve_id: props.data?.eleve_id,
        classe_id: classeDesignationId,
        annee_scolaire_id: yearId,
      };
      const response = await API_ELEVE.PROMOTION.create(data, token);
      if (response.data.status === 201) {
        toast.success("Affectation effectuée avec succès", { duration: 3000 });
        props.dispatchReload();
        props.setOpen(false);
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      // console.log(error);
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <div className="AffecteEleve">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <EditRoad className="ico" />
              <span>Affectation - Nouvelle promotion</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          <div className="item">
            <label>Nom</label>
            <input
              placeholder="Nom..."
              type="text"
              name="nom_Nom"
              value={props.data?.nom?.toUpperCase()}
              // onChange={handleChange}
              disabled
            />
          </div>
          <div className="item">
            <label>Post-nom</label>
            <input
              placeholder="Post-nom..."
              type="text"
              name="nom_Post-nom"
              value={props.data?.postnom?.toUpperCase()}
              // onChange={handleChange}
              disabled
            />
          </div>
          <div className="item">
            <label>Prénom</label>
            <input
              placeholder="Prénom..."
              type="text"
              name="nom_Prénom"
              value={props.data?.prenom?.toUpperCase()}
              // onChange={handleChange}
              disabled
            />
          </div>

          <div className="item">
            <label>Nouvelle année</label>
            <input
              placeholder="Prénom..."
              type="text"
              name="nom_Prénom"
              value={props.currentYear}
              // onChange={handleChange}
              disabled
            />
          </div>

          <div className="item promotion">
            <label>Nouvelle Promotion - Année: {props.currentYear}</label>
            <select
              onChange={(e) => setClasseDesignationId(e.target.value)}
              value={classeDesignationId}
            >
              <option value="">-- Selectionner promotion --</option>

              {props.dataClasse.map((item, index) => {
                return (
                  <option key={index} value={item.classe_id}>
                    {item.classe_designation.toUpperCase()}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleAffecteClasse}>Affecter</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AffecteEleve;
